import React, { Component } from "react";
import { Link } from "react-router-dom";
import TicketingCart from "../component/TicketingCart";
import MainLayout from "../mainLayout";
import TextField from "./../component/TextField";
import TextEditor from "../component/TextEditor";
//moment import
import moment from "moment-timezone";
//Service import
import service from "../services";
import Loader from "../component/loader";
//Validation import
import SimpleReactValidator from "simple-react-validator";
// Editors
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import { convertFromRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import isEqual from "lodash/isEqual";
import cloneDeep from "lodash/cloneDeep";

let sub;

const content = {
  entityMap: {},
  blocks: [
    {
      key: "637gr",
      text: "Initialized from content state.",
      type: "unstyled",
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {}
    }
  ]
};
export default class LandingPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      editorState: EditorState.createEmpty(),
      activetab: 0,
      getTickitingDetails: [],
      getTickitingDocs: [],
      loaderFlag: false,
      title: "",
      headerSubtitle: EditorState.createEmpty(),
      updatedAt: moment.utc().subtract(420, "minutes"),
      lastUpdatedBy:"",
      
      data: [
        {
          label: "Locations Landing Page",
          Content: ""
        },
      ],
      isLandingPageEdited: false
    };
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.apiserve = new service();
  }

  componentDidMount = async () => {
    this.getTickiting();
    this.getTickitingEvent();
    this.setState({
      loaderFlag: true,
      initialData: this.getCurrentFormData(),
      isLandingPageEdited: false
    });
    this.apiserve.sendevent("location|getLastUpdated", {type:"4"});
  };

  getTickitingEvent = () => {
    sub = this.apiserve.getevent().subscribe(response => {
      switch (response.event) {
        case "location|landingPage|getDetails":
          if (!response.error) {
              
            if (this.state.headerSubtitle){
              const blocksFromHtml = htmlToDraft(response.data && response.data && response.data.subtitle ? response.data && response.data && response.data.subtitle : '');
              const { contentBlocks, entityMap } = blocksFromHtml;
              const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
              const headerSubtitle = EditorState.createWithContent(contentState);
              this.setState({
                headerSubtitle : headerSubtitle,
                isEdited: false
              })
            }else this.setState({ loaderFlag: false });
            if(response.data){
              this.setState({
                getTickitingDocs: response.data,
                title: response.data.title,
                id: response.data._id,
                fname: response.data.updatedBy.fname,
                lname: response.data.updatedBy.lname,
                updatedAt: moment.tz(response.data.updatedAt, "US/Mountain"),
                loaderFlag: false,
                isLandingPageEdited: false
              }, () => {
                this.setState({ initialData: this.getCurrentFormData(), isLandingPageEdited: false });
              });
            }else this.setState({ loaderFlag: false });
          } else this.setState({ loaderFlag: false });
          break;
        case "ticketCms|ticketHome|edit":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error
            });
          } else {
            this.setState({ loaderFlag: false }, () =>
              this.apiserve.success("Landing updated successful.")
            );
            this.getTickiting();
          }
          break;
          case "location|getLastUpdated":
            if(!response.error){
                this.setState({
                    lastUpdatedBy:response?.data?.updatedBy,
                    // lastUpdatedAt:response?.data?.updatedAt,
                })
            }    
            break;
        case "location|landingPage|create":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error
            });
          } else {
            this.setState({ loaderFlag: false }, () =>
              this.apiserve.success("Landing Created successful.")
            );
            this.getTickiting();
          }
      }
    });
  };

  getTickiting = () => {
    this.apiserve.sendevent("location|landingPage|getDetails", {});
  };

  getCurrentFormData = () => {
    const normalizeDraftHtml = (editorState) => {
      if (!editorState || typeof editorState === 'string') return '';
      const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
      return (html === '<p></p>\n' || html === '<p></p>') ? '' : html;
    };

    return cloneDeep({
      title: this.state.title,
      subtitle: normalizeDraftHtml(this.state.headerSubtitle),
    });
  }

  markLandingPageEdited = () => {
    if (this.state.initialData) {
      const isDirty = !isEqual(this.state.initialData, this.getCurrentFormData());
      if (this.state.isLandingPageEdited !== isDirty) {
        this.setState({ isLandingPageEdited: isDirty });
      }
    }
  }
  onEditorStateChange = headerSubtitle => {
    this.updateState({
      headerSubtitle
    });
  };

  updateState = (data, callback) => {
    this.setState({
      ...data,
    }, () => {
      this.markLandingPageEdited();
      if (callback) callback();
    });
  };

  handelChange = e => {
    this.updateState({
      [e.target.name]: e.target.value
    });
  };

  getContent = (field) => {
    const value = field ? convertToRaw(field.getCurrentContent()) : ''
    return draftToHtml(value);
  }

  submitFn = async e => {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.setState({ loaderFlag: true });
      const markup = this.getContent(this.state.headerSubtitle);
      if(this.state.id){
        let updateTicket = {
          id: this.state.id,
          title: this.state.title,
          subtitle: markup,
        };
        
        this.apiserve.sendevent("location|getLastUpdated", {type:"4"});
        this.apiserve.sendevent("location|landingPage|create", updateTicket);
        // debugger
      }else{
        let data = {
            title: this.state.title,
            subtitle: markup, 
        }
        this.apiserve.sendevent("location|getLastUpdated", {type:"4"});
        this.apiserve.sendevent("location|landingPage|create", data);
      }
    }
    else{
      this.validator.showMessages();
      this.forceUpdate();
    }
  };
  TabClick = index => {
    this.setState({
      activetab: index
    });
  };
  validateModel = () => {
    this.setState({
      errorMsg: false
    });
  };

  cancelBTN = e => {
    e.preventDefault();
    window.location.reload();
    // this.props.history.push({pathaname: '/ticketing'})
  };
  render() {
    const { updatedAt } = this.state;
    var UpdatedBy = `${this.state.lastUpdatedBy.fname ? this.state.lastUpdatedBy.fname : ""} ${this.state.lastUpdatedBy.lname ? this.state.lastUpdatedBy.lname : ""}`;

    return (
      <React.Fragment>
        <div className="right_side_wrapper artistView_wrapper">
        <ul className="fpg_admin_tab disp_flex">
            <li className="active">
                <p className="uppercase text_left">
                    <div>Locations Landing Page</div>
                    {/* <span onClick={this.AddVenue}><PlusIcon  /></span> */}
                </p>
            </li>
        </ul>

          {this.state.activetab === 0 ? (
            <>
              <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                {/* <Link className="back_link"> <svg width="5" height="10" viewBox="0 0 5 10" fill="none"> <path d="M5 0L0 5L5 10V0Z" fill="black"/> </svg> Back to List</Link> */}
                <p></p>
                <p className="update_date">
                
                  Last Update: {updatedAt.format("hh:mm A")} MT -{updatedAt.format("MM/DD/YYYY")} 
                  Last Updated By: {UpdatedBy ? UpdatedBy : ''}
                </p>
              </div>
              <div className="ticketing_content fpg_tabcontent">
                <div className="ticketing_wrapper">
                  <form>
                    <div className="">
                      <div className="field_row horizontal_field">
                        <TextField
                          type="text"
                          label="Header Title"
                          name="title"
                          value={this.state.title}
                          onChange={this.handelChange}
                          fpgerror={this.validator.message('title', this.state.title, 'required')}
                        />
                      </div>
                      <div className="field_row horizontal_field">
                        <div className="field_row_inner">
                          <label>Header Subtitle</label>
                          <div className="field_input relative editor_wrapper">
                            <TextEditor
                              name="headerSubtitle"
                              editorState={this.state.headerSubtitle}
                              value={this.state.headerSubtitle}
                              onEditorStateChange={e => this.onEditorStateChange(e)}
                            />
                            {/* <textarea name="headerSubtitle" value={item.headerSubtitle}></textarea>  */}
                          </div>
                        </div>
                      </div>
                   
                    </div>
                    <div className="text_center field_row w_100 buttons_outer">
                      <button className="uppercase" onClick={this.cancelBTN}>
                        CANCEL
                      </button>
                      {/* <button className="uppercase prev_btn">PREviEW</button> */}
                      <button
                        className={this.state.id && !this.state.isLandingPageEdited ? "disabled" : "active"}
                        disabled={this.state.id && !this.state.isLandingPageEdited}
                        type="button"
                        onClick={e => this.submitFn(e)}
                      >
                        SAVE
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </>
          ) : (
            ""
          )}
          {this.state.activetab === 1 ? <TicketingCart /> : ""}
        </div>

        <div className={`user_popup ${this.state.errorMsg ? "active" : ""}`}>
          <span className="popup_overlay"></span>
          <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
            <div className="approve_popup_header text_center relative">
              <p>{this.state.errorMsgShow}</p>
            </div>
            <div className="content">
              <div className="field_row text_center">
                <button className="small_btn active" onClick={this.validateModel}>
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
        {this.state.loaderFlag ? <Loader /> : ""}
      </React.Fragment>
    );
  }
}
